// User vote fixation
$(".btn-user-vote").click(function (e) {
    e.preventDefault();
    Swal.fire({
        title: 'Ви дійсно бажаєте проголосувати за цього кандидата?',
        showDenyButton: true,
        confirmButtonText: `Так`,
        denyButtonText: `Ні`,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            let button = $(this);
            let form = button.closest('form');
            let url = form.attr("action");

            $.ajax({
                type: "POST",
                url: url,
                data: form.serialize(),
                success: function (data) {
                    if (data.status == "user-make-vote") {
                        Swal.fire('Дякуэмо, Ваш голос прийнято!', '', 'success')
                    }
                    if(data.status == "user-dedied-vote")
                    {
                        Swal.fire('Ви вже проголосували в цьому голосуванні!', '', 'info')
                    }
                    if(data.status == "user-region-different")
                    {
                        Swal.fire('Ви не можете голосувати за кандидата не в Вашому регіоні!', '', 'info')
                    }
                },
                error: function (data) {
                    // Massive of errors
                    var errors = data.responseJSON;
                    console.log(errors);
                    let fields = [];
                    for (key in data.responseJSON.errors) {
                        fields.push(key);
                    }
                }
            });
        }
    })
});